import { getAppInfo } from '@nike/get-app-info';
var site = 'nikecom';

// slimmed down version of the eventBuilder.js function from cart/faves
export default function getViewAppData() {
  var appInfo = getAppInfo();
  var nameOrPageOrViewChannel = appInfo.viewChannel;
  return {
    app: appInfo,
    view: {
      pageName: "".concat(site, ">").concat(nameOrPageOrViewChannel, ">").concat(appInfo.viewName),
      pageType: nameOrPageOrViewChannel,
      pageDetail: appInfo.viewName
    }
  };
}